import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { BellRing, Check, MessageCircle } from "lucide-react";

function tomorrowRange() {
  const s = new Date(); s.setHours(0, 0, 0, 0); s.setDate(s.getDate() + 1);
  const e = new Date(s); e.setDate(e.getDate() + 1);
  return { start: s.toISOString(), end: e.toISOString() };
}

const buildMsg = (a) => {
  const d = new Date(a.start_at);
  const first = (a.user_name || "").split(" ")[0];
  const data = d.toLocaleDateString("pt-BR");
  const hora = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return `Olá, ${first}! Lembrete do seu horário amanhã, ${data} às ${hora}, para ${a.service_title} no Arya Studio K&C. Lembre-se: desmarcações só com 48h de antecedência. Até lá!`;
};

export default function RemindersCard() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/reminders", { params: tomorrowRange() }).then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async (a) => {
    if (!a.phone) return toast.error("Cliente sem telefone cadastrado");
    const phone = String(a.phone).replace(/\D/g, "");
    window.open(`https://wa.me/${phone.startsWith("55") ? phone : "55" + phone}?text=${encodeURIComponent(buildMsg(a))}`, "_blank");
    await api.post(`/admin/appointments/${a.appointment_id}/reminder-sent`);
    toast.success("Lembrete marcado como enviado");
    load();
  };

  return (
    <div className="card-arya p-6" data-testid="reminders-card">
      <div className="flex items-center gap-2 mb-3">
        <BellRing size={16} className="text-[color:var(--sun-600)]"/>
        <h3 className="font-serif text-xl">Lembretes de amanhã</h3>
        <span className="tag-sun ml-auto" data-testid="reminders-count">{items.filter(a => !a.reminder_sent_at).length} pendentes</span>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[color:var(--ink-500)]" data-testid="reminders-empty">Nenhum horário marcado para amanhã.</p>
      ) : (
        <ul className="divide-y divide-[var(--line)]">
          {items.map(a => (
            <li key={a.appointment_id} className="py-3 flex items-center justify-between gap-3" data-testid={`reminder-${a.appointment_id}`}>
              <div>
                <p className="font-display font-semibold">{a.user_name}</p>
                <p className="text-xs text-[color:var(--ink-500)]">
                  {new Date(a.start_at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })} · {a.service_title} · {a.phone || "sem telefone"}
                </p>
              </div>
              {a.reminder_sent_at ? (
                <button onClick={() => send(a)} className="text-xs inline-flex items-center gap-1 text-[color:var(--success)]" title="Reenviar" data-testid={`reminder-sent-${a.appointment_id}`}>
                  <Check size={14}/> Enviado
                </button>
              ) : (
                <button onClick={() => send(a)} className="btn-gold !py-1 !px-3 text-xs inline-flex items-center gap-1" data-testid={`reminder-send-${a.appointment_id}`}>
                  <MessageCircle size={12}/> Lembrar
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      <p className="text-[10px] text-[color:var(--ink-500)] mt-3">Abre o WhatsApp com a mensagem pronta e marca como enviado.</p>
    </div>
  );
}
